export default __webpack_public_path__ + "static/media/CHANGELOG.5a86218f.md";